import { useState } from 'react';
import { ArrowRight, RotateCcw } from 'lucide-react';

interface Props {
  totalStakeholders: number;
  warningsCount: number;
  canProceed: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  busy: boolean;
}

export function ConfirmationPanel({
  totalStakeholders,
  warningsCount,
  canProceed,
  onConfirm,
  onCancel,
  busy,
}: Props): JSX.Element {
  const [checked, setChecked] = useState(false);

  return (
    <section className="card flex flex-col gap-5 p-6 lg:flex-row lg:items-center lg:justify-between">
      <div className="max-w-2xl space-y-2">
        <h2 className="text-lg font-semibold text-brand-ink">Confirmação da importação</h2>
        <p className="text-sm text-brand-slate">
          Os gráficos são gerados somente após esta confirmação. Serão processados{' '}
          <strong className="text-brand-ink">{totalStakeholders}</strong> stakeholders
          {warningsCount > 0 ? `, com ${warningsCount} alerta(s) registrado(s)` : ''}. Todos os percentuais são
          calculados pelo sistema sobre esse total.
        </p>
        <label className="flex items-start gap-3 text-sm text-brand-graphite">
          <input
            type="checkbox"
            className="mt-0.5 h-4 w-4 rounded border-brand-line text-brand-red focus:ring-brand-red"
            checked={checked}
            onChange={(event) => setChecked(event.target.checked)}
            disabled={!canProceed || busy}
          />
          Confiro que os dados exibidos correspondem à planilha enviada.
        </label>
      </div>

      <div className="flex flex-wrap gap-3">
        <button type="button" className="btn-secondary" onClick={onCancel} disabled={busy}>
          <RotateCcw className="h-4 w-4" aria-hidden />
          Cancelar e enviar nova planilha
        </button>
        <button type="button" className="btn-primary" onClick={onConfirm} disabled={!canProceed || !checked || busy}>
          Confirmar dados e gerar gráficos
          <ArrowRight className="h-4 w-4" aria-hidden />
        </button>
      </div>
    </section>
  );
}
